import React, { useEffect, useState } from "react";

import { Dialog, Portal, SimpleGrid, Select, HStack, CloseButton, Button, useSelectContext, createListCollection } from "@chakra-ui/react";

import { highLightRouteForLaneletViewWithCSV } from "../../../../../utilies/OsmUtility";
import { useAppStore } from "../../../../../context/store";
import { useMapObjects } from "../../../../../context/MapObjectsContext";
const LayersCompareWith = () => {
  // state
  const showCompareDialog = useAppStore((s) => s.showCompareDialog);
  const currentLayer = useAppStore((s) => s.currentLayer);
  const { mapObjects, setMapObjects, mapObjectsRef } = useMapObjects();

  // setters / refs
  const setShowCompareDialog = useAppStore.getState().setShowCompareDialog;
  const setCurrentLayer = useAppStore.getState().setCurrentLayer;

  const [csvLayersPropertiesOption, setCsvLayersPropertiesOption] = useState([]);
  const [selectedValue, setSelectedValue] = useState([]);

  const TypeSelectValue = () => {
    const select = useSelectContext();
    const items = select.selectedItems;
    if (items[0]) {
      return (
        <Select.ValueText placeholder="Select member">
          <HStack>{items[0].name}</HStack>
        </Select.ValueText>
      );
    } else {
      return null;
    }
  };

  useEffect(() => {
    if (showCompareDialog) {
      let temp = [];
      for (const key in mapObjects) {
        if (mapObjects[key].type === "CSV" && mapObjects[key].lanelet_ids.length > 0) {
          temp.push({
            name: mapObjects[key].file_name,
            id: mapObjects[key].id,
          });
        }
      }
      setCsvLayersPropertiesOption(temp);
    }
  }, [currentLayer, showCompareDialog]);

  const csvLayersCollection = React.useMemo(
    () =>
      createListCollection({
        items: csvLayersPropertiesOption,
        itemToString: (item) => item.name,
        itemToValue: (item) => item.id,
      }),
    [csvLayersPropertiesOption],
  );

  return (
    <Dialog.Root
      lazyMount
      open={showCompareDialog}
      onOpenChange={(e) => {
        setShowCompareDialog(e.open);
        if (!Boolean(e.open)) {
          setCurrentLayer(null);
        }
      }}
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header>
              <Dialog.Title>Highlight Route</Dialog.Title>
            </Dialog.Header>
            <Dialog.Body>
              <SimpleGrid columns={1} gap={1}>
                <Select.Root
                  collection={csvLayersCollection}
                  size="sm"
                  value={selectedValue}
                  positioning={{ sameWidth: true }}
                  onValueChange={(value) => {
                    setSelectedValue([value.value[0]]);
                  }}
                >
                  <Select.HiddenSelect />
                  <Select.Label>Geojson Properties</Select.Label>
                  <Select.Control>
                    <Select.Trigger>
                      <TypeSelectValue />
                    </Select.Trigger>
                    <Select.IndicatorGroup>
                      <Select.Indicator />
                    </Select.IndicatorGroup>
                  </Select.Control>
                  <Select.Positioner>
                    <Select.Content>
                      {csvLayersPropertiesOption.map((item) => (
                        <Select.Item item={item} key={item.name} justifyContent="flex-start">
                          {item.name}
                          <Select.ItemIndicator />
                        </Select.Item>
                      ))}
                    </Select.Content>
                  </Select.Positioner>
                </Select.Root>
              </SimpleGrid>
            </Dialog.Body>
            <Dialog.Footer>
              <Dialog.ActionTrigger asChild>
                <Button variant="outline">Cancel</Button>
              </Dialog.ActionTrigger>
              <Button
                onClick={() => {
                  for (const key in mapObjects) {
                    if (mapObjects[key].id === selectedValue[0]) {
                      let d1 = mapObjects[key].lanelet_ids; // from csv
                      let d2 = currentLayer.dataSource;

                      highLightRouteForLaneletViewWithCSV(d1, d2);
                      break;
                    }
                  }

                  setShowCompareDialog(false);
                }}
              >
                Compare
              </Button>
              <Button
                colorPalette={"red"}
                onClick={() => {
                  for (const key in mapObjects) {
                    if (mapObjects[key].id === selectedValue[0]) {
                      let d1 = mapObjects[key].lanelet_ids;
                      let d2 = currentLayer.dataSource;
                      highLightRouteForLaneletViewWithCSV(d1, d2, true);
                      break;
                    }
                  }

                  setShowCompareDialog(false);
                }}
              >
                Reset
              </Button>
            </Dialog.Footer>
            <Dialog.CloseTrigger asChild>
              <CloseButton size="sm" />
            </Dialog.CloseTrigger>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

export default LayersCompareWith;
